import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { I18n } from '../../_ui-core_/base/package/services/package/i18n/i18n.de';
import { updateMetaDescription, updateMetaTitle } from '../../_ui-core_/base/package/util/html-helper';
import App from '../../app';
import style from './error-page-404.css?inline';
import '../../_ui-core_/components/ui-inlined-svg/ui-inlined-svg';

const CName = 'error-page-404';

@customElement(CName)
export class ErrorPage404 extends LitElement {
  static readonly styles = [unsafeCSS(style)];

  connectedCallback(): void {
    super.connectedCallback();
    App.instance.content.getSEOHtmlContent('error-page-404').then((res) => {
      if (!this.isConnected) return;
      const title = res?.content?.metaTitle;
      const decription = res?.content?.metaDescription;
      if (title) {
        updateMetaTitle(title);
      }
      if (decription) {
        updateMetaDescription(decription);
      }
    });
  }

  render() {
    const assetUrl = new URL('/assets/ui-core/icons/slot-404-icon.svg', import.meta.url).href;

    return html`
      <div class="container">
        <span class="logo" @click=${this._handleClick}></span>
        <div class="msg">
          <div class="gfx">
            <ui-inlined-svg .defer=${true} .src=${assetUrl}></ui-inlined-svg>
          </div>
          <div class="txt">
            <h1 class="header">${window.$app.$t.get(I18n.pageNotFound.header)}</h1>
            <p class="text">${window.$app.$t.get(I18n.pageNotFound.text)}</p>
            <ui-btn @click=${this._handleClick} variant="secondary">${window.$app.$t.get(I18n.pageNotFound.backHomeButton)}</ui-btn>
          </div>
        </div>
      </div>
    `;
  }

  private _handleClick() {
    window.$app.track.pageNotFound('lobby', App.instance.router.currentLocation().route.path.toString());
    App.instance.router.navigateToHome();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: ErrorPage404;
  }
}
